import React from 'react';
import './SuccessComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

function SuccessComponent({firstName, lingua, onClose, successContext}) {
    const label = successContext === 'success' ? lingua.read('lex.account.confirm.button') : lingua.read('button.continue');
    let header;
    let title;

    switch (successContext) {
        case 'passwordchange':
            header = lingua.read('lex.header.success.simple');
            title = lingua.read('lex.password.change.success');
            break;
        case 'success':
            header = lingua.read('lex.header.confirmed.account');
            title = lingua.read('lex.account.confirm.title');
            break;
        case 'invalidLink':
            header = lingua.read('lex.password.reset.title');
            title = lingua.read('lex.ticket.success');
            break;
        case 'legacy':
            header = lingua.read('lex.header.success.simple');
            title = lingua.read('lex.header.success.legacy');
            break;
        default:
            header = firstName ? lingua.read('lex.header.success', {firstName}) : '';
            title = lingua.read('lex.signup.success.subtitle');
            break;
    }

    return (
        <div className="SuccessComponent text-center">
            <div className="SvgImage">
                <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66">
                    <g fill="none" fillRule="evenodd" stroke="#0067DB" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
                        <path d="M1.659 33a31.452 31.452 0 0 1 2.385-11.994 31.362 31.362 0 0 1 6.793-10.168 31.71 31.71 0 0 1 4.747-3.897 31.543 31.543 0 0 1 5.422-2.897A31.4 31.4 0 0 1 33 1.66c2.05 0 4.1.203 6.116.603 2.009.4 3.978 1 5.878 1.782a31.372 31.372 0 0 1 16.962 16.962 31.611 31.611 0 0 1 1.782 5.878c.4 2.016.603 4.066.603 6.116s-.203 4.1-.603 6.116c-.4 2.009-1 3.98-1.782 5.878a31.529 31.529 0 0 1-6.797 10.168 31.372 31.372 0 0 1-10.165 6.794c-1.9.783-3.869 1.382-5.878 1.782-2.016.4-4.066.603-6.116.603a31.4 31.4 0 0 1-11.994-2.385 31.543 31.543 0 0 1-5.422-2.897 31.71 31.71 0 0 1-4.746-3.897A31.362 31.362 0 0 1 1.658 33z"/>
                        <path d="M36.967 34.532l-9.592 9.592-9.592-9.592M48.277 23.223l-11.31 11.31"/>
                    </g>
                </svg>
            </div>
            <div><h2 className="Header">{header}</h2></div>
            <p className="SuccessPadding lead">{title}</p>
            <div className="SuccessButton">
                <form>
                    <ButtonPrimary id="success" label={label} onClick={onClose} />
                </form>
            </div>
        </div>
    );
}

export default SuccessComponent;
